import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-ssgc',
  templateUrl: './about-ssgc.component.html',
  styleUrls: ['./about-ssgc.component.scss']
})
export class AboutSsgcComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
